import { useEffect, useReducer, useRef } from 'react';
import { navigateToFirstError } from './validationNavigation';

export function useValidationNavigation(isPending = false) {
  const elementRef = useRef<HTMLFormElement>(null);
  const [attempt, requestNavigation] = useReducer((value: number) => value + 1, 0);
  const handledAttempt = useRef(0);
  useEffect(() => {
    if (attempt === handledAttempt.current || isPending) return;
    let cleanup: (() => void) | undefined;
    let committedFrame = 0;
    const frame = requestAnimationFrame(() => {
      // Server-error adapters write field metadata in an effect after the reply.
      committedFrame = requestAnimationFrame(() => {
        handledAttempt.current = attempt;
        if (elementRef.current) cleanup = navigateToFirstError(elementRef.current);
      });
    });
    return () => { cancelAnimationFrame(frame); cancelAnimationFrame(committedFrame); cleanup?.(); };
  }, [attempt, isPending]);
  return { elementRef, requestNavigation };
}
